// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { Box, Button, Divider, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

// CUSTOM
import { mtDividerUpTable } from '../../../commons';
import { hasPemissions } from '../../../commons/utils';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { TableRatingsDevices } from './components/TableRatingsDevices';
import { DialogRatingsDevice } from './components/modals/DialogRatingsDevice';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../commons/texts';
import { BannerInfoDispositivos } from './components/BannerInfoDispositivos';
import AddIcon from '@mui/icons-material/Add';

export const GestionDispositivos = () => {
  // DISPATCH
  const dispatch = useDispatch();

  // USE STATE
  const [modalCreate, setModalCreate] = useState(false);
  const [canCreate, setCanCreate] = useState(false);

  // USE EFFECT
  useEffect(() => {
    hasPrmissionsCreate();
  }, []);

  // CONST FUNCTIONS
  const hasPrmissionsCreate = async () => {
    const hasPermissions = await hasPemissions(
      'modulo.calificaciones',
      'modulo.calificacion.dispositivos',
      'create'
    );

    if (hasPermissions) {
      setCanCreate(true);
    } else {
      setCanCreate(true); // FORCED FOR NOW TO TEST
    }
  };

  // FUNCTIONS OPEN MODALS
  const openModal = async () => {
    setModalCreate(true);
  };

  const handleCloseModalCrear = async () => {
    setModalCreate(false);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <BreadCrumbsAndTitle
            title="Gestión de Dispositivos"
            mainModule="calificaciones"
            parent="Configuraciones"
            icon="DevicesOther"
            action="Dispositivos"
          />

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <AlertsInformativos
              type={'info'}
              title={'info'}
              content={alertInformativo.gestionDispositivos}
            />
          </Typography>
        </Box>

        {canCreate && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={openModal}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)',
            }}
          >
            Crear Dispositivo
          </Button>
        )}
      </Box>

      <Divider sx={{ marginBottom: mtDividerUpTable }} />
      <DialogRatingsDevice open={modalCreate} handleCloseModalCrear={handleCloseModalCrear} />

      <TableRatingsDevices />

      <BannerInfoDispositivos />
    </Box>
  );
};

export default GestionDispositivos;
